import gql from 'graphql-tag'
import client from '../../stores/apollo'
import { WorkplaceGroupFragment } from '@api/fragments'
import { IWorkplaceGroup } from '@api/types'
import handleFetchResult from '@utils/handleFetchResult'

const mutation = gql`
  mutation CreateWorkplaceGroupMutation($input: CreateWorkplaceGroupInput!) {
    createWorkplaceGroup(input: $input) {
      workplaceGroup {
        ...WorkplaceGroupFragment
      }
    }
  }
  ${WorkplaceGroupFragment}
`

interface IPayload {
  createWorkplaceGroup: {
    workplaceGroup: IWorkplaceGroup
  }
}

const mutateHandler = handleFetchResult<IPayload, IWorkplaceGroup>({
  handler: (data) => data.createWorkplaceGroup.workplaceGroup,
  name: 'Spaces',
})

export default async function createWorkplaceGroup({
  name,
}: // color
{
  name: string
  // color: string
}): Promise<IWorkplaceGroup> {
  const input = {
    name,
    // color
  }

  return client.gql
    .mutate({
      mutation,
      variables: { input },
    })
    .then(mutateHandler)
}
